import { type ForwardedRef, type PropsWithChildren } from "react";

import { type Table } from "@devexpress/dx-react-grid-bootstrap4";

import { SELECTION_COLUMN_WIDTH, URL_COLUMN_ID } from "../constants";

interface Props extends PropsWithChildren<Table.DataCellProps> {
  forwardedRef?: ForwardedRef<HTMLTableCellElement>;
}

export const TableCell = ({
  column,
  value,
  children,
  tableRow,
  tableColumn,
  row,
  forwardedRef,
  ...restProps
}: Props) => {
  let cellValue = children || value;
  if (
    cellValue === undefined ||
    cellValue === null ||
    Number.isNaN(cellValue)
  ) {
    cellValue = "";
  }

  return (
    <td
      ref={forwardedRef}
      {...restProps}
      style={
        column.name === URL_COLUMN_ID
          ? { left: `${SELECTION_COLUMN_WIDTH}px` }
          : {}
      }
    >
      {cellValue}
    </td>
  );
};
